import { useContext } from 'react';
import { Card, CardBody, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { BILL_MANAGEMENT_CONST, ValidationLabel } from '../../constant';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import LoaderResoinse from '../../loader/loader';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';

const PaymentAddModel = (props) => {
  const { onSubmit, close, error } = props;
  const {
    paymetnModal,
    paymentBillFormData,
    setPaymentBillFormData,
    allPrice,
    setAllPrice,
    isMinusAmount,
    setIsMinusAmount
  } = useContext(BillManagementContext);

  const { loaderShow } = useContext(OrganizationContext);
  const handelChange = (e) => {
    const { name, value } = e.target;
    setPaymentBillFormData((prev) => {
      return {
        ...prev,
        [name]: value
      };
    });
    if (name === 'amount') {
      const dueAmount = Number(allPrice.totalAmount) - Number(allPrice.paidAmount) - Number(value);

      setAllPrice((prev) => ({
        ...prev,
        dueAmount
      }));

      setIsMinusAmount(dueAmount < 0);
    }
  };

  const paymentType = ['CASH', 'UPI', 'BANK', 'CHEQUE'];

  return (
    <>
      <Modal size="lg" isOpen={paymetnModal} toggle={() => close()}>
        {loaderShow === true && <LoaderResoinse />}
        <ModalHeader toggle={() => close()}>
          <span>{BILL_MANAGEMENT_CONST.ADD_PAYMENT}</span>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Row className="g-3">
                    <Col md="4" className="text-center ">
                      <p className="text-muted mb-1">Total Amount</p>
                      <h4 className="fw-bold text-primary">{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(allPrice?.totalAmount || 0)}</h4>
                    </Col>
                    <Col md="4" className="text-center ">
                      <p className="text-muted mb-1">Payed Amount</p>
                      <h4 className="fw-bold text-success">{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(allPrice?.paidAmount || 0)}</h4>
                    </Col>
                    <Col md="4" className="text-center ">
                      <p className="text-muted mb-1">Due Amount</p>
                      <h4 className="fw-bold text-danger">{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(allPrice?.dueAmount || 0)}</h4>
                    </Col>
                  </Row>
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    <Row>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && !paymentBillFormData.paymentDate ? 'validation' : 'non-validation'}
                        >
                          {error && !paymentBillFormData.paymentDate
                            ? ValidationLabel.paymentDateRequired
                            : ValidationLabel.paymentDate}
                        </Label>
                        <Input
                          className={`${
                            error && !paymentBillFormData.paymentDate ? 'inputValidation' : ''
                          } "form-control`}
                          name="paymentDate"
                          type="date"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={paymentBillFormData.paymentDate}
                          max={new Date().toISOString().split('T')[0]}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && !paymentBillFormData.amount ? 'validation' : 'non-validation'}
                        >
                          {error && !paymentBillFormData.amount
                            ? ValidationLabel.amountRequired
                            : ValidationLabel.amount}
                        </Label>
                        <Input
                          className={`${
                            (error && !paymentBillFormData.amount) || isMinusAmount ? 'inputValidation' : ''
                          } "form-control`}
                          name="amount"
                          type="number"
                          placeholder="Total Amount"
                          id="validationCustom01"
                          onChange={handelChange}
                          onWheel={(e) => e.target.blur()}
                          value={paymentBillFormData.amount}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6 mb-4">
                        <Label
                          htmlFor="validationCustom01"
                          className={error && !paymentBillFormData.paymentMode ? 'validation' : 'non-validation'}
                        >
                          {' '}
                          {error && !paymentBillFormData.paymentMode
                            ? ValidationLabel.paymentModeRequired
                            : ValidationLabel.paymentMode}
                        </Label>
                        <select
                          className={`${
                            error && !paymentBillFormData.paymentMode ? 'inputValidation' : ''
                          } form-select`}
                          name="paymentMode"
                          typeof="number"
                          value={paymentBillFormData.paymentMode}
                          onChange={handelChange}
                        >
                          <option value="">--select--</option>
                          {paymentType.map((elem) => {
                            return (
                              <option
                                value={elem}
                                key={elem}
                                selected={elem === paymentBillFormData.paymentMode ? 'selected' : ''}
                              >
                                {elem}
                              </option>
                            );
                          })}
                        </select>
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                      <Col md="6 mb-4">
                        <Label htmlFor="validationCustom01" className={'non-validation'}>
                          {'Reference No'}
                        </Label>
                        <Input
                          className={`form-control`}
                          name="referenceNo"
                          type="text"
                          placeholder="Reference No"
                          id="validationCustom01"
                          onChange={handelChange}
                          value={paymentBillFormData.referenceNo}
                          onWheel={(e) => e.target.blur()}
                        />
                        <div className="invalid-feedback">{'Please provide a valid ORG Name.'}</div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12 mb-4">
                        <Label htmlFor="validationCustom09">{'Notes'}</Label>
                        <textarea
                          className="form-control"
                          name="notes"
                          id="validationCustom09"
                          type="text"
                          placeholder="Notes"
                          onChange={handelChange}
                          value={paymentBillFormData.notes}
                        />
                        <div className="invalid-feedback">{'Please provide a valid State.'}</div>
                      </Col>
                    </Row>

                    <Row style={{ paddingTop: '30px' }}>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        value="Submit"
                        disabled={loaderShow === true || isMinusAmount ? 'disabled' : ''}
                      >
                        {'Submit'}
                      </button>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PaymentAddModel;
